import { depositsSlice } from './slice'

// Deposits List Redcuers
export const { setDepositsListLoading } = depositsSlice.actions
export const { setDepositsListError } = depositsSlice.actions
export const { setDepositsListData } = depositsSlice.actions
export const { resetDepositsListState } = depositsSlice.actions
export const { setSelectedDeposits } = depositsSlice.actions
export const { setFilteredDeposits } = depositsSlice.actions
export const { setDepositsFilterText } = depositsSlice.actions
// Remove Deposits Redcuers
export const { setRemoveDepositsLoading } = depositsSlice.actions
export const { setRemoveDepositsError } = depositsSlice.actions
export const { setRemoveDepositsSuccess } = depositsSlice.actions
export const { resetRemoveDepositsState } = depositsSlice.actions
// Get Deposit Details
export const { setFetchDepositsLoading } = depositsSlice.actions
export const { setFetchDepositsError } = depositsSlice.actions
export const { setFetchDepositsData } = depositsSlice.actions
export const { resetFetchDepositsState } = depositsSlice.actions
// Validate Deposit Reducers
export const { setValidateDepositLoading } = depositsSlice.actions
export const { setValidateDepositSuccess } = depositsSlice.actions
export const { setValidateDepositCurrentId } = depositsSlice.actions
export const { resetValidateDepositState } = depositsSlice.actions
// Validate Deposit Reducers
export const { setCancelDepositLoading } = depositsSlice.actions
export const { setCancelDepositSuccess } = depositsSlice.actions
export const { setCancelDepositCurrentId } = depositsSlice.actions
export const { resetCancelDepositState } = depositsSlice.actions
